// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"77972e5f","470":"36b6db6b","847":"ddbd1edc"}[chunkId] + ".chunk.css";
};